import React from 'react'
import Pt from 'prop-types'
import Ipt from 'react-immutable-proptypes'

import './Icon.css'

export default function ProductIcon({ Component = 'div', product }) {
  const type = product.get('type')

  return (
    <Component className="product-icon">
      <img
        src={`/icons/service-icon-${type.toLowerCase()}.png`}
        alt={product.get('type')}
      />
    </Component>
  )
}

ProductIcon.propTypes = {
  Component: Pt.string,
  product: Ipt.record.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Product/Icon.jsx